<template>
  <client-only>
    <div v-if="user">
      <ToolbarComponent />
      <DialogComponent />
      <ChangeCreditCardDialogComponent />
      <EditAddressDialogComponent />
      <div v-if="user && $store.state.localStorage.currentUser" class="main_edit_profile_container">
        <div v-if="user.id === $store.state.localStorage.currentUser.id && !$device.isMobileOrTablet" class="left">
          <div class="edit_profile_menu box_container">
            <div :class="{'selected': state === 'my'}" @click="changeState('my')">
              My profile
            </div>
            <div :class="{'selected': state === 'edit'}" @click="changeState('edit')">
              Edit profile
            </div>
            <div class="section_devider" />
            <div :class="{'selected': state === 'orders'}" @click="changeState('orders')">
              My Orders
            </div>
            <div :class="{'selected': state === 'payment_method'}" @click="changeState('payment_method')">
              Payment methods
            </div>
            <div :class="{'selected': state === 'shipping_addresses'}" @click="changeState('shipping_addresses')">
              Shipping addresses
            </div>
            <div class="section_devider" />
            <div :class="{'selected': state === 'credits'}" @click="changeState('credits')">
              Cretdits & Referral
            </div>
            <div :class="{'selected': state === 'password'}" @click="changeState('password')">
              Password
            </div>
            <div class="section_devider" />
            <div :class="{'selected': state === 'contact'}" @click="changeState('contact')">
              Contact
            </div>
          </div>
        </div>
        <div class="right box_container" :class="{'other_user' : user.id !== $store.state.localStorage.currentUser.id}">
          <template v-if="state === 'my'">
            <component
              :is="getCenterComponent"
              v-if="getCenterComponent"
              :user="user"
              :parent-component-data="getCenterComponentData"
            />
          </template>
          <template v-if="state === 'edit'">
            <div class="section_title">
              Edit Profile
            </div>
            <div class="sub_section edit_profile_section">
              <div class="sub_section_title">
                Profile
              </div>
              <div class="sub_section_content">
                <div class="user_image_section">
                  <template>
                    <div class="profile_image">
                      <img
                        v-lazy-load :data-src="$store.state.localStorage.currentUser.profilePhotoThumbnail || $store.state.localStorage.currentUser.image || 'https://s3.amazonaws.com/app.770apps.images/defult_pic.png'"
                       alt="user photo">
                    </div>
                    <div v-if="changePhoto" class="profile_image_selector">
                      <div class="file_input">
                        <label class="btn btn-primary search-file-btn">
                          <input
                            ref="myFileInput"
                            name="file1"
                            type="file"
                            style="display:None;"
                            @change="changeListner($event)"
                          > <span class="choose_file">Choose file</span>
                        </label>
                        <span class="file_name">{{ getFileName }}</span>
                      </div>
                      <p class="allowed_pictures">
                        Allowed file types JPG, GIF or PNG.
                      </p>
                      <div class="change_photo_actions">
                        <div class="gotit_button" :class="{'disabled': !imageSrc}" @click="uploadPhoto()">
                          Upload Photo
                        </div>
                        <a class="cancel_button" href="#" @click="changePhoto = false">cancel</a>
                      </div>
                    </div>
                    <div v-else>
                      <div class="gotit_button" @click="changePhoto = true">
                        Change Photo
                      </div>
                      <a class="delete_profile_image" href="#" @click="deleteCurrentPhoto()">Delete photo</a>
                    </div>
                  </template>
                </div>
                <div class="input_placeholder">
                  Full Name
                </div>
                <input v-model="user.name" class="gotit_input" placeholder="Your name" @keyup="onProfileInfoChanged()">
                <div class="input_placeholder">
                  Username
                </div>
                <input v-model="user.username" disabled class="gotit_input" placeholder="User Name">
                <div class="input_placeholder">
                  Bio
                </div>
                <textarea
                  v-model="user.bio"
                  class="gotit_input bio"
                  placeholder="Tell us about yourself"
                  rows="3"
                  @keyup="onProfileInfoChanged()"
                />
                <div class="input_placeholder">
                  Email
                </div>
                <input v-model="user.email" class="gotit_input" placeholder="Email" @keyup="onProfileInfoChanged()">
                <div class="input_placeholder">
                  Phone Number
                </div>
                <input
                  v-model="user.phone"
                  class="gotit_input"
                  placeholder="Phone number"
                  @keyup="onProfileInfoChanged()"
                >
                <div class="input_placeholder">
                  Gender
                </div>
                <p class="gender_select">
                  <span class="trick-select option">
                    <select v-model="user.gender" class="select-boxes2" @change="onGenderChanged()">
                      <option
                        v-for="(gender, index) in genders"
                        :key="index"
                        :value="gender.toLowerCase()"
                      >{{ gender }}</option>
                    </select>
                  </span>
                </p>
                <div class="input_placeholder">
                  Birth date
                </div>
                <input
                  type="date"
                  :value="userBirthDay && userBirthDay.toISOString().split('T')[0]"
                  value-type="format"
                  class="gotit_input"
                  @input="userBirthDay = $event.target.valueAsDate"
                >
              </div>
            </div>
          </template>
          <template v-if="state === 'password'">
            <div class="section_title">
              Change Password
            </div>
            <div class="sub_section">
              <div class="sub_section_title" />
              <div class="sub_section_content">
                <div class="input_placeholder">
                  Current Password
                </div>
                <input v-model="oldPassword" class="gotit_input" type="password" placeholder="Old Password">
                <div class="input_placeholder">
                  New Password
                </div>
                <input v-model="newPassword" class="gotit_input" type="password" placeholder="New Password">
                <div class="input_placeholder">
                  Confirm Password
                </div>
                <input v-model="confirmPassword" class="gotit_input" type="password" placeholder="Confirm password">
              </div>
            </div>
          </template>
          <template v-if="state === 'contact'">
            <div class="section_title">
              Contact us
            </div>
            <div class="sub_section">
              <div class="sub_section_title" />
              <div class="sub_section_content">
                <div class="contact_us_container">
                  <div class="cu_details">
                    <div class="icon">
                      <img v-lazy-load data-src="/place.svg" alt="place icon">
                    </div>
                    <div class="info">
                      <div>3500 s. Dupont Hway</div>
                      <div>Dover, Delaware, 19901</div>
                    </div>
                  </div>
                  <div class="cu_details">
                    <div class="icon">
                      <img v-lazy-load data-src="/alternate_email.svg" alt="gotit email">
                    </div>
                    <div class="info">
                      <div><a href="mailto:info@gotitapp.net">info@gotitapp.net</a></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-if="state === 'credits'">
            <div class="section_title">
              My Credits
            </div>
            <div class="sub_section">
              <div class="sub_section_title">
                Your credit can be used in the following stores
              </div>
              <div class="sub_section_content">
                <div class="offer_admin_store_grid">
                  <div v-for="store in adminStores" :key="store.id" class="pointer" @click="showStore(store.id)">
                    <img v-lazy-load :data-src="store.image" class="offer_admin_store" alt="store image">
                    <span>{{ store.name }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="sub_section">
              <div class="sub_section_title">
                Your Credits
              </div>
              <div class="sub_section_content">
                <OfferComponent
                  v-for="offer in offers"
                  :key="offer.id"
                  :offer="offer"
                />
              </div>
            </div>
          </template>
          <template v-if="state === 'orders'">
            <div class="section_title">
              My Orders
            </div>
            <OrderComponent v-for="order in orders" :key="order.id" :show-order-details-button="true" :order="order" />
          </template>
          <template v-if="state === 'payment_method'">
            <div class="payment_method_title">
              <div class="payment_method">
                Payment method
              </div>
              <div class="strech" />
              <div class="add_payment_method gotit_button" @click="addPaymentMethod()">
                Add payment method
              </div>
            </div>
            <div>
              <template v-if="stripe && stripe.data.length > 0">
                <div class="cards_container">
                  <div v-for="(card, index) of stripe.data" :key="index" class="stripe_card">
                    <div>
                      <div>
                        <img v-lazy-load :data-src="getCartIcon(card.brand)" class="card_icon" alt="card brand"> {{ card.brand }} - ***{{ card.last4 }}
                      </div>
                      <div class="label">
                        NAME ON CARD
                      </div>
                      <div>{{ card.name }}</div>
                      <div class="label">
                        EXPIRATION DATE
                      </div>
                      <div>{{ card.expMonth + '/' + card.expYear }}</div>
                    </div>
                    <div class="billing_address">
                      <div class="label">
                        BILLING ADDRESS
                      </div>
                      <div>{{ card.addressLine1 }}</div>
                      <div>
                        {{ card.addressCity }}, {{ card.addressState }}, {{ card.addressCountry }} {{
                          card.addressZip
                        }}
                      </div>
                      <div class="strech" />
                      <div class="card_actions">
                        <button
                          :disabled="loading && cardProcessing === card.id"
                          class="primary_card pointer"
                          @click="removeCard(card)"
                        >
                          Remove Card
                        </button>
                        <button
                          v-if="card.metadata.isDefault !== 'true'"
                          class="primary_card pointer"
                          @click="setPrimary(card)"
                        >
                          Set As Primary
                        </button>
                        <button v-if="card.metadata.isDefault === 'true'" class="primary_card pointer primary">
                          Primary
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div v-if="!stripe" class="cards_container">
                <div class="stripe_card animated-background" />
                <div class="stripe_card animated-background" />
                <div class="stripe_card animated-background" />
              </div>
            </div>
          </template>
          <template v-if="state === 'shipping_addresses'">
            <div class="payment_method_title">
              <div class="payment_method">
                Shipping Addresses
              </div>
              <div class="strech" />
              <div class="add_payment_method gotit_button" @click="addShippingAddress()">
                Add shipping address
              </div>
            </div>
            <div>
              <template v-if="addressHistory && addressHistory.length > 0">
                <div class="cards_container">
                  <div v-for="(address, index) of addressHistory" :key="index" class="stripe_card address_card">
                    <div class="address_name">
                      {{ address.firstName }} {{ address.lastName }} - {{ address.zip }}
                    </div>
                    <div class="address_details">
                      <div>
                        <div class="label">
                          SHIPPING ADDRESS
                        </div>
                        <div>{{ address.firstName }} {{ address.lastName }}</div>
                        <div>{{ address.street }}</div>
                        <div>{{ address.city + ' ' + address.state + ' ' + address.zip }}</div>
                        <div>USA</div>
                      </div>
                      <div class="strech" />
                      <div class="billing_address">
                        <div class="label">
                          TELEPHONE & EMAIL
                        </div>
                        <div>{{ address.phone }}</div>
                        <div>{{ address.email }}</div>
                        <div class="strech" />
                      </div>
                    </div>
                    <div class="card_actions">
                      <button
                        v-if="address.isDefault !== 'true'"
                        class="primary_card pointer"
                        @click="setPrimary(address)"
                      >
                        Set As Primary
                      </button>
                      <button v-if="address.isDefault === 'true'" class="primary_card pointer primary">
                        Primary
                      </button>
                    </div>
                  </div>
                </div>
              </template>
              <div v-if="!addressHistory" class="cards_container">
                <div class="stripe_card animated-background" />
                <div class="stripe_card animated-background" />
                <div class="stripe_card animated-background" />
              </div>
            </div>
          </template>
          <div v-if="showSaveChangesButton" class="save_changes">
            <div class="strech" />
            <button :class="{'disabled': isSaveButtonDisabled}" class="gotit_button" @click="onSaveChangesClick()">
              {{ pleaseWait ? 'Please wait' : changesSaved ? 'Changes saved!' : 'Save Changes' }}
            </button>
          </div>
        </div>
      </div>
      <NewsComponent />
    </div>
  </client-only>
</template>
<script>

import AbstractComponent from './AbstractComponent'
import NewsComponent from './NewsComponent'
import OfferComponent from './OfferComponent'
import ToolbarComponent from './ToolbarComponent'
import DialogComponent from './DialogComponent'
import OrderComponent from './OrderComponent'
import ChangeCreditCardDialogComponent from './ChangeCreditCardDialogComponent'
import EditAddressDialogComponent from './EditAddressDialogComponent'

export default {
  name: 'ProfileRootComponent',
  components: {
    EditAddressDialogComponent,
    ChangeCreditCardDialogComponent,
    OrderComponent,
    DialogComponent,
    ToolbarComponent,
    OfferComponent,
    NewsComponent
  },
  extends: AbstractComponent,
  props: {
    propUser: Object
  },
  data () {
    return {
      componentData: null,
      state: 'my',
      test: null,
      user: this.propUser,
      genders: ['male', 'female', 'other'],
      userBirthDay: null,
      redirectWebUser: true,
      showSaveChangesButton: false,
      oldPassword: '',
      newPassword: '',
      hideCanvas: false,
      isProfileImage: true,
      cardProcessing: '',
      loading: false,
      file: null,
      imageSrc: null,
      popupActive: false,
      croppedImageSelected: false,
      cropImg: null,
      stripe: null,
      addressHistory: null,
      imageData: {},
      changePhoto: false,
      fileName: '',
      confirmPassword: '',
      orders: [],
      ordersFetched: false,
      profileDetailsChanged: false,
      pleaseWait: false,
      changesSaved: false,
      firstDateSet: true,
      adminStores: [],
      offers: [],
      paymentSuccess: 'false',
      reg: /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    }
  },
  computed: {
    getFileName () {
      if (this.fileName) {
        if (this.fileName.length > 35) {
          const start = this.fileName.substring(0, 15)
          const end = this.fileName.substring(this.fileName.length - 20, this.fileName.length)
          return start + '...' + end
        } else {
          return this.fileName
        }
      } else {
        return 'No file has been selected'
      }
    },
    isSaveButtonDisabled () {
      switch (this.state) {
        case 'edit':
          return !this.profileDetailsChanged || this.pleaseWait || !this.reg.test(this.user.email) || !this.userBirthDay
        case 'password':
          return this.newPassword.length < 5 ||
              this.confirmPassword.length < 5 ||
              this.newPassword !== this.confirmPassword ||
              this.newPassword === this.oldPassword ||
              this.oldPassword.length < 5 ||
              this.pleaseWait
        default:
          return true
      }
    },
    getToolbarComponent () {
      return () => import(`../components/${this.componentData.components.filter((item) => {
        return item.componentId === 'toolbar'
      })[0].type}`)
    },
    getCenterComponent () {
      if (this.componentData) {
        const component = this.componentData.components.filter((item) => {
          return item.componentId === 'center_component'
        })
        if (component && component[0]) {
          return () => import(`../components/${component[0].type}`)
        }
      }
      return null
    },
    getLeftComponent () {
      const component = this.componentData.components.filter((item) => {
        return item.componentId === 'left_component'
      })
      if (component && component[0]) {
        return () => import(`../components/${component[0].type}`)
      }
      return null
    },
    getRightComponent () {
      const component = this.componentData.components.filter((item) => {
        return item.componentId === 'right_component'
      })
      if (component && component[0]) {
        return () => import(`../components/${component[0].type}`)
      }
      return null
    },
    getCenterComponentData () {
      return this.componentData.components.filter((item) => {
        return item.componentId === 'center_component'
      })[0]
    }
  },
  watch: {
    userBirthDay (newVal, old) {
      if (this.firstDateSet) {
        this.firstDateSet = false
      } else {
        this.profileDetailsChanged = true
      }
    },
    cropImg (newVal, oldVal) {
      this.profileDetailsChanged = true
    }
  },
  mounted () {
    this.userBirthDay = new Date(this.user.birthday)
    this.state = this.$route.hash.replace('#', '').toLowerCase() || 'my'
    if (this.state === 'wantit' || this.state === 'gotit') {
      this.state = 'my'
    }
    if (this.state !== 'my') {
      this.changeState(this.state)
    }
  },
  methods: {
    deleteCurrentPhoto () {
      const sure = confirm('are you sure?')
      if (sure) {
        this.$vs.loading({
          type: 'border'
        })
        const image = this.defaultProfileImage
        this.$store.commit('localStorage/updateUser', { image })
        this.$store.dispatch('api/usersUpdate', this.$store.state.localStorage.currentUser)
          .then((data) => {
            this.$store.commit('localStorage/setCurrentUser', data[0])
            this.$vs.loading.close()
            this.showModal = false
          })
      }
    },
    changeListner (event) {
      const image = new Image()
      const file = event.target.files[0]
      if (file) {
        // this.imageFile.emit(file)
        this.fileName = file.name
        const myReader = new FileReader()
        myReader.onloadend = (loadEvent) => {
          image.src = loadEvent.target.result
          this.imageData.imag = image.src
          this.imageSrc = image.src
          // this.$refs.cropper.setImage(image)
          // this.emitCroppedImage()
        }
        myReader.readAsDataURL(file)
      }
    },
    async uploadPhoto () {
      this.$vs.loading({
        type: 'border'
      })
      const res = await this.$store.dispatch('api/uploadImageNew', this.imageSrc)
      const image = res.Location
      this.$store.commit('localStorage/updateUser', { image })
      this.$store.dispatch('api/usersUpdate', this.$store.state.localStorage.currentUser)
        .then((data) => {
          this.$refs.myFileInput.value = ''
          this.imageSrc = null
          this.user = data[0]
          this.$store.commit('localStorage/setCurrentUser', data[0])
          this.$vs.loading.close()
          this.changePhoto = false
        })
    },
    async changeState (state) {
      this.state = state
      this.$router.replace({
        path: '/profile#' + state
      })
      switch (this.state) {
        case 'my':
          this.showSaveChangesButton = false
          break
        case 'edit':
          this.showSaveChangesButton = true
          break
        case 'password':
          this.showSaveChangesButton = true
          break
        case 'shipping_addresses':
          if (!this.addressHistory) {
            this.addressHistory = await this.$store.dispatch('api/getUserAddresses')
          }
          break
        case 'payment_method':
          if (!this.stripe) {
            this.stripe = await this.$store.dispatch('api/selectCreditCards')
          }
          break
        case 'credits':
          this.showSaveChangesButton = false
          if (!this.creditsFetched) {
            this.$store.dispatch('api/selectStores', {
              filter: 'ADMIN_STORES'
            })
              .then((res) => {
                this.adminStores = res
              })
            this.offers = await this.$store.dispatch('api/selectOffers', {
              filter: 'USER'
            })
            this.creditsFetched = true
          }
          break
        case 'orders':
          this.showSaveChangesButton = false
          if (!this.ordersFetched) {
            this.orders = await this.$store.dispatch('api/selectOrders', {})
            this.paymentSuccess = this.$route.query.ps
            this.ordersFetched = true
          }
          break
      }
    },
    async setPrimary (card) {
      this.$vs.loading({
        type: 'border'
      })
      this.loading = true
      this.stripe.data.forEach((cc, index) => {
        if (cc.id === card.id) {
          cc.metadata.isDefault = 'true'
        } else {
          delete cc.metadata.isDefault
        }
        return cc
      })
      this.stripe.data = this.stripe.data.splice(0)

      // eslint-disable-next-line no-unused-vars
      const edit = await this.$store.dispatch('api/editCreditCard', { sourceId: card.id })
      this.$store.dispatch('api/trackEvent', {
        eventName: 'credit_card_edited',
        params: {
          path: this.$route.path
        }
      }).then().catch()
      this.loading = false
      this.$vs.loading.close()
    },
    addPaymentMethod () {
      if (this.stripe) {
        this.$root.$emit('toggle_change_credit_card', { stripe: this.stripe, addNewCardOnly: true })
      } else {
        setTimeout(() => {
          this.addPaymentMethod()
        }, 1000)
      }
    },
    addShippingAddress () {
      this.$root.$emit('toggle_edit_address')
    },
    async removeCard (card) {
      this.$vs.loading({
        type: 'border'
      })
      this.cardProcessing = card.id
      this.loading = true
      let indexToRemove = -1
      // eslint-disable-next-line no-unused-vars
      const removeResponse = await this.$store.dispatch('api/removeCreditCard', { sourceId: card.id })
      this.$store.dispatch('api/trackEvent', {
        eventName: 'credit_card_removed',
        params: {
          path: this.$route.path
        }
      }).then().catch()
      for (let i = 0; i < this.stripe.data.length; i++) {
        if (this.stripe.data[i].id === this.cardProcessing) {
          indexToRemove = i
        }
      }
      this.stripe.data.splice(indexToRemove, 1)
      this.cardProcessing = ''
      this.$vs.loading.close()
      this.loading = false
    },
    getCartIcon (brand) {
      // Express, Diners Club, Discover, JCB, MasterCard, UnionPay, Visa, or Unknown.
      switch (brand.toLowerCase()) {
        case 'visa':
          return '/visa.svg'
        case 'express':
          return '/american-express.svg'
        case 'master card':
          return '/mastercard.svg'
        case 'diners club':
          return '/mastercard.svg'
        case 'discover':
          return '/mastercard.svg'
        case 'jcb':
          return '/mastercard.svg'
        case 'masterCard':
          return '/mastercard.svg'
        case 'unionpay':
          return '/mastercard.svg'
        default:
          return '/visa.svg'
      }
    },
    onProfileInfoChanged () {
      this.profileDetailsChanged = true
    },
    async onSaveChangesClick () {
      switch (this.state) {
        case 'edit':
          this.pleaseWait = true
          if (this.cropImg) {
            this.$vs.loading({
              type: 'border'
            })
            let image = ''
            const res = await this.$store.dispatch('api/uploadImageNew', this.cropImg)
            image = res.Location
            this.$store.commit('localStorage/updateUser', { image })
          }
          this.updateUser()
          break
        case 'password':
          this.pleaseWait = true
          // eslint-disable-next-line no-case-declarations
          const params = {
            id: this.user.id,
            typeParam: this.oldPassword,
            typeParam2: this.newPassword,
            type: 'CHANGE_PASSWORD'
          }
          this.user = await this.$store.dispatch('api/userExecute', params)
          this.pleaseWait = false
          this.oldPassword = ''
          this.newPassword = ''
          this.confirmPassword = ''
          this.$root.$emit('show_dialog', {
            title: 'Greate!',
            message: 'New Password Saved'
          })
          break
        default:
          break
      }
    },
    onUserReady () {
      this.user = { stamVar: '', ...this.$store.state.localStorage.currentUser }
      this.userBirthDay = this.user.birthday
    },
    changePassword () {
      this.$store.commit('localStorage/setCurrentUser', this.user)
    },
    onGenderChanged () {
      this.$store.commit('localStorage/setCurrentUser', this.user)
      this.updateUser()
    },
    updateUser () {
      this.pleaseWait = true
      this.$store.commit('localStorage/setBirthDate', this.userBirthDay)
      this.$store.dispatch('api/usersUpdate', this.user)
        .then((data) => {
          this.changesSaved = true
          this.$store.commit('localStorage/setCurrentUser', data[0])
          this.$vs.loading.close()
          this.pleaseWait = false
          this.profileDetailsChanged = false
          setTimeout(() => {
            this.changesSaved = false
          }, 1500)
        }).catch(() => {
          this.$vs.loading.close()
          this.pleaseWait = false
        })
    },
    onImageClick () {
      this.$refs.file.click()
    },
    getPlaceHolder () {
      if (this.isProfileImage) {
        return '/avatar.png'
      } else {
        return '/item-placeholder.png'
      }
    },
    saveImage () {
      this.croppedImageSelected = true
      this.popupActive = false
    },
    cropImage () {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
    },
    getCropBoxData () {
      this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4)
    },
    getData () {
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4)
    }
  }
}
</script>
<style scoped>
.main_containter {
  display: flex;
  flex-direction: column;
}

.main {
  padding-top: 1em;
  margin: auto;
  width: 80%;
  display: flex;
  justify-content: center;
  overflow: auto;
}

.main > div {
  flex: 1;
}

.right {
  width: 950px;
}

.mobile_design .right {
  width: 100%;
}

.edit_profile_menu {
  width: 250px;
  margin-right: 1em;
  display: flex;
  flex-direction: column;
}

.edit_profile_menu div {
  padding: 0.5em 0.5em 0.5em 1em;
  cursor: pointer;
}

.edit_profile_menu div:hover {
  color: #383d48
}

/*.selected {
  border-left: 3px solid #ed4956;
  background-color: #F6F6F7;
  color: #383d48;
  font-family: HKGroteskBold, serif;
}*/

/*.main_edit_profile_container {*/
/*  !*max-width: calc(250px + 892px + 1em);*!*/
/*  margin-top: 1em;*/
/*  color: #646f7b;*/
/*  display: flex;*/
/*  flex-direction: row;*/
/*  justify-content: center;*/
/*  margin-left: calc(-250px/2);*/
/*}*/

/* bobo */
.main_edit_profile_container {
  max-width: calc(250px + 935px + 3em);
  padding-top: calc(70px + 7.5em);
  margin: 1em auto auto;
  color: #646f7b;
  display: flex;
  flex-direction: row;
}

.mobile_design .main_edit_profile_container {
  padding-top: calc(42px + 4.3em);
  margin: unset;
  max-width: unset;
  height: 100vh;
  padding-bottom: 50px;
}

.edit_profile_menu {
  width: 250px;
  display: flex;
  flex-direction: column;
}

.edit_profile_menu div {
  padding: 0.5em 0.5em 0.5em 1em;
  cursor: pointer;
}

.edit_profile_menu div:hover {
  color: #383d48
}

.main_edit_profile_container .right {
  margin-left: 1em;
  padding: 1em;
  width: 960px;
}

.mobile_design .main_edit_profile_container .right {
  width: 100%;
  margin-left: unset;
  padding: unset;
}

.gotit_input {
  width: 510px;
}

.selected {
  border-left: 3px solid #ed4956;
  background-color: #F6F6F7;
  color: #383d48;
  font-family: HKGroteskBold, serif;
}

.section_title {
  font-family: HKGroteskBold, serif;
  font-size: 15px;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 1em;
  padding-bottom: 1em;
  color: #6f727d;
}

.sub_section {
  display: flex;
  flex-direction: row;
}

.sub_section_title {
  width: 180px !important;
}

.sub_section_content {
  width: 510px;
}

.user_image_section .gotit_button {
  line-height: 30px;
  background-color: #ebeced;
  display: flex;
  flex-direction: row;
  color: #434649;
  font-size: 12px;
}

.user_image_section {
  display: flex;
  flex-direction: row;
  margin-bottom: 1em;
  align-items: center;
}

.profile_image {
  margin-right: 1em;
}

.profile_image img {
  border-radius: 50%;
  width: 90px;
  height: 90px;
}

.change_password {
  line-height: 30px;
  margin-top: 1em;
}

.input_placeholder {
  font-family: HKGroteskBold;
  color: #393d4d;
  margin-bottom: 0.4em;
  margin-top: 1em;
}

.order {
  max-width: 800px;
}

.right.box_container {
  max-height: calc(100vh - 49px - 50px - 1em - 1em);
  overflow: scroll;
  display: flex;
  background-color: white;
  flex-direction: column;
  padding-bottom: unset;
}

.mobile_design .right.box_container {
  max-height: unset;
}

.offer_stores {
  width: 920px;
  margin: auto auto 2em;
  padding-top: 2em;
}

.credit_stores {
  font-size: 2em;
  color: #B12704;
  text-align: center;
  margin-bottom: 1em;
  font-weight: bold;
}

.offers_containter {
  /*display: flex;*/
}

.offer_admin_store {
  width: 60px;
  height: 60px;
}

.offer_admin_store_grid {
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(auto-fill, 70px);
  grid-gap: 5px;
}

.offer {
  width: 100%;
}

.save_changes {
  display: flex;
  flex-direction: row;
  align-items: end;
  border-top: 1px solid #f2f2f2;
  padding-top: 1em;
  position: sticky;
  bottom: 0;
  background-color: white;
  padding-bottom: 1em;
  margin-top: 1em;
}

.disabled {
  opacity: 0.5;
  cursor: unset;
}

.date_picker {
  padding-bottom: calc(67px + 1em);
}

.mobile_design .box_container {
  background-color: unset !important;
  border: unset !important;
}

.right.box_container.other_user {
  margin-left: auto;
  margin-right: auto;
}

.other_user {
  margin-left: auto;
  margin-right: auto;
}

.mobile_design .other_user {
  padding: 0;
}

.select_image_content {
  display: flex;
  flex-direction: row;
  padding: 1em;
  align-items: center;
}

.profile_image_selector {
  margin-left: 1em;
  flex-grow: 1;
}

.select_image_content p {
  font-size: 12px;
  line-height: 16px;
  color: #8a8f9c;
  padding: 10px 0 12px;
  font-weight: 500;
}

.delete_profile_image, .cancel_button {
  text-decoration: none;
  color: #9da1ab;
  cursor: pointer;
  font-size: 12px;
}

.delete_profile_image {
  display: inline-block;
  margin-top: 1em;
}

.cancel_button {
  margin-left: 1em;
}

.disabled {
  opacity: 0.5;
  cursor: unset;
}

.file_input {
  border-radius: 5px;
  background: #ebeced;
}

.choose_file {
  height: 39px;
  padding: 0 12px;
  font-family: HKGroteskBold;
  font-size: 13px;
  line-height: 39px;
  cursor: pointer;
  margin-right: 7px;
  color: #393d4d;
  vertical-align: middle;
  font-weight: bold;
  background: none;
}

.file_name {
  font-size: 13px;
  white-space: nowrap;
}

.change_photo_actions {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  align-items: center;
}

.cancel_button .gotit_button {
  font-size: 12px;
}

.allowed_pictures {
  margin-top: 1em;
  margin-bottom: 1em;
}

.payment_method_title {
  display: flex;
  align-items: center;
}

.add_payment_method {
  background-color: #ebeced;
  color: #393d4d;
  font-size: 12px;
}

.payment_method_title {
  font-family: HKGroteskBold;
  color: #373d48;
  font-size: 15px;
}

.cards_container {
  margin-top: 1em;
  display: grid;
  grid-template-columns: repeat(2, 400px);
  justify-items: center;
  justify-content: space-between;
}

.stripe_card {
  padding: 1em;
  margin-bottom: 1em;
  display: flex;
  width: 400px;
  flex-direction: row;
  font-size: 13px;
  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.2);
  background-color: white;
  border-radius: 5px;
  font-family: 'HKGroteskRegular', serif;
}

.stripe_card > div {
  flex-grow: 1;
}

.address_card {
  flex-direction: column;
}

.address_card .card_actions {
  padding-top: 1em;
  margin-top: 0.5em;
  border-top: 1px solid rgba(77, 78, 84, 0.14);
}

.address_name {
  font-family: HKGroteskBold;
  line-height: 21px;
  font-size: 16px;
  color: #393b42;
  font-weight: 600;
}

.address_details {
  display: flex;
  flex-direction: row;
}

.label {
  font-size: 10px;
  color: #91969c;
  line-height: 18px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  padding: 0;
  font-weight: 500;
}

.primary_card {
  line-height: 31px;
  height: 33px;
  vertical-align: middle;
  box-shadow: none;
  font-size: 13px;
  color: #434649;
  border-color: #EDEEF0;
  background: #EDEEF0;
  display: inline-block;
  border-radius: 5px;
  padding: 0 13px;
  font-weight: bold;
  text-align: center;
  border-width: 1px;
  border-style: solid;
}

.primary_card[disabled] {
  background: #f2f2f2 !important;
  border-color: #f2f2f2 !important;
  box-shadow: none;
  color: #CDCFD1;
  text-shadow: none;
  cursor: default;
}

.billing_address {
  display: flex;
  flex-direction: column;
}

.card_actions {
  text-align: right;
}

.primary {
  background-color: #ed4956;
  color: white;
  cursor: unset;
}

.placeholder {
  display: block;
  margin-bottom: 0.4em;
}

.card_element_title {
  margin-top: 1em;
}

.disabled {
  opacity: 0.5;
  cursor: unset;
}

.sub_title {
  margin-top: 2em;
  margin-bottom: 1em;
  font-family: HKGroteskBold;
}

.card_icon {
  width: 30px;
}

.stripe_card.animated-background {
  height: 132px;
}

.section_devider {
  background-color: rgba(77, 78, 84, 0.11);
  height: 1px;
  padding: unset !important;
}

.gotit_input.bio {

}

.cu_details {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 1em;
}

.cu_details .icon {
  width: 40px;
}

.cu_details .info {
  flex-grow: 1;
}
</style>
